import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { F, Flex, Button } from 'nallian-shared-ui/lib/components';
import PrincipalApp from './PrincipalApp';

const FieldFlex = styled(Flex)`
  && .field {
    width: 100%;
  }
`;

const PrincipalRoles = ({ apps, fields, editMode, readOnly, formName }) => {
  const { t } = useTranslation();

  const handleAddFieldClick = useCallback(() => fields.push({ isNew: true }), [fields]);
  const handleRemoveFieldClick = useCallback((_, { i }) => fields.remove(i), [fields]);

  return (
    <F.Field error={false}>
      <Flex fluid direction="column">
        <FieldFlex fluid margin="1rem 0 0 0" direction="column" alignItems="flex-start">
          {fields.map((f, index) => (
            <PrincipalApp
              readOnly={readOnly}
              editMode={editMode}
              fields={fields}
              index={index}
              field={f}
              apps={apps}
              formName={formName}
              key={`principalApp_${index.toString()}`}
              handleRemoveFieldClick={handleRemoveFieldClick}
            />
          ))}
          {!fields.length && <Flex>{t('noAppsFeaturesRolesDefined')}</Flex>}
          {!readOnly && fields.length < apps.length && (
            <Flex fluid justifyContent="flex-end" margin="1rem 0 0 0">
              <Button
                linkbutton
                icon="add"
                type="button"
                tabindex="-1"
                content={t('addApplication')}
                onClick={handleAddFieldClick}
              />
            </Flex>
          )}
        </FieldFlex>
      </Flex>
    </F.Field>
  );
};

PrincipalRoles.propTypes = {
  readOnly: PropTypes.bool.isRequired,
  fields: PropTypes.array.isRequired,
  editMode: PropTypes.bool.isRequired,
  apps: PropTypes.array,
  formName: PropTypes.string,
};

PrincipalRoles.defaultProps = { apps: [], formName: undefined };

export default PrincipalRoles;
